
import { h, Fragment, render } from 'preact'
import { useState, useRef } from 'preact/hooks'
import { createPortal } from 'preact/compat'
import { useLocalStorage } from './hooks/useLocalStorage'
import { useVisible } from './hooks/useVisible'
import { SavedJobsButton } from './components/SavedJobsButton'
import classnames from 'classnames'
import { json } from './utility/dom'
import { filter } from './utility/object'


export function init() {
	

	const element = document.getElementById('saved-jobs-menu')
	const singleComponents = [...document.querySelectorAll('.js-saved-jobs-button-component')]
	const { searchUrl } = json('#site-settings')

	element && render(createPortal(<SavedJobsMenu searchUrl={searchUrl} />, element), element)

	singleComponents.map(el => {
		const id = el.getAttribute('data-id')
		const title = el.getAttribute('data-title')
		const subtitle = el.getAttribute('data-subtitle')
		const href = el.getAttribute('data-href')
		render(createPortal(<SavedJobsSingleButton id={id} title={title} subtitle={subtitle} href={href} />, el), el)
	})
}


function SavedJobsSingleButton({ id, title, subtitle, href }) {
	const [savedJobs, setSaved] = useLocalStorage('savedJobs', {})
	const saved = savedJobs[id] || false
	const save = () => setSaved({
		...savedJobs, 
		[id]: { id, title, subtitle, href } 
	})
	const unsave = () => setSaved({
		...savedJobs,
		[id] : undefined
	})
	return <SavedJobsButton text saved={saved} save={save} unsave={unsave} />
}


function SavedJobsMenu({ searchUrl }) {

	const [savedJobs, setSaved] = useLocalStorage('savedJobs', {})
	const jobArray = Object.values(savedJobs).filter(Boolean)
	const remove = id => setSaved(filter({...savedJobs, [id] : undefined }))

	const { ref, visible, setVisible } = useVisible(false)
	
	return <div ref={ref}>
		<button class="button button--icon-left button--icon-saved-jobs-white" onClick={() => setVisible(!visible)}>
			<span class="hide inline@small">Saved jobs </span>
			{jobArray.length > 0 && <span class="saved-jobs-button__number">({jobArray.length})</span>}
		</button>
		{visible && <>
			<div class="saved-jobs-menu__dropdown">
				{jobArray.length > 0 && <>
					<ul class="reset-list">
						{jobArray.map(job => <Job savedJobs={savedJobs} onRemove={remove} {...job} />)}
					</ul>
				</> || <>
					<div class="text-center">
						No saved jobs found<br />
						<small><a href={searchUrl}>Search for roles</a></small>
					</div>
				</>}
			</div>
		</>}
	</div>
}


function Job({ id, title, subtitle, href, savedJobs, onRemove }) {

	const saved = savedJobs[id] || false

	return <div class="action-row">
		<div class="action-row__main">
			<a href={href} class="action-row__title">{title}</a>
			<div class="action-row__subtitle">{subtitle}</div>
		</div>
		<div class="action-row__actions">
			<SavedJobsButton saved={saved} unsave={() => onRemove(id)} />
		</div>
	</div>
}